// extracted by mini-css-extract-plugin
export default {"header":"T_tP8c","userContent":"WCfGQi"};